// src/Components/OutOfHomeCampaign/CampaignNameInput.js
import React, { useCallback } from 'react';
import { TextInput, required, useInput } from 'react-admin';

export const CampaignNameInput = (props) => {
    const {
        input: { onChange: onNameChange, value: nameValue }, // Use input instead of field
    } = useInput({ source: 'name' });

    const {
        input: { onChange: onWeekNumberChange, value: currentWeekNumber }, // Use input for week_number
    } = useInput({ source: 'week_number' });

    const extractWeekNumber = useCallback(
        (name) => {
            const weekMatch = name.match(/(?:week|wk)\s*(\d{1,2})/i);
            return weekMatch ? parseInt(weekMatch[1], 10) : null;
        },
        []
    );

    const handleBlur = useCallback(
        (event) => {

            const weekNumber = extractWeekNumber(event.target.value);

            if (weekNumber) {
                onWeekNumberChange(weekNumber);
            }
        },
        [onWeekNumberChange, currentWeekNumber, extractWeekNumber]
    );

    return (
        <TextInput
            source="name"
            label="Name"
            validate={required()}
            onBlur={handleBlur}
            onChange={onNameChange}
            value={nameValue}
        />
    );
};